import './App.css';
import AppNavbar from './components/AppNavbar';
import { BrowserRouter, Routes, Route, useLocation, useOutlet } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { createRef, lazy, Suspense } from 'react';
import FooterComponent from './components/FooterComponent';

const HomeComponent = lazy(() => import('./components/HomeComponent'));
const CurrentGamesComponent = lazy(() => import('./components/CurrentGamesComponent'));
const AboutComponent = lazy(() => import('./components/AboutComponent'));
const TcgComponent = lazy(() => import('./components/activities/TcgComponent'));
const BookClubComponent = lazy(() => import('./components/BookClubComponent'));
const OtherActivitiesComponent = lazy(() => import('./components/OtherActivitiesComponent'));

const routes = [
  { path: '/', name: 'Home', Component: HomeComponent, nodeRef: createRef() },
  { path: '/current-events', name: 'Current Events', Component: CurrentGamesComponent, nodeRef: createRef() },
  { path: '/about', name: 'About', Component: AboutComponent, nodeRef: createRef() },
  { path: '/book-club', name: 'Book Club', Component: BookClubComponent, nodeRef: createRef() },
  { path: '/activities', name: 'Other Activities', Component: OtherActivitiesComponent, nodeRef: createRef() },
  { path: '/game-masters', name: 'Game Masters', Component: lazy(() => import('./components/GameMaster')), nodeRef: createRef() },
];

function AnimatedRoutes() {
  const location = useLocation();
  const currentOutlet = useOutlet();
  const { nodeRef } = routes.find((route) => route.path === location.pathname) ?? {};
  
  return (
    <SwitchTransition>
      <CSSTransition
        key={location.pathname}
        nodeRef={nodeRef}
        timeout={300}
        classNames="page"
        unmountOnExit
      >
        {(state) => (
          <div ref={nodeRef} className="page">
            <Suspense fallback={<div className="loading">Loading...</div>}>
              {currentOutlet}
            </Suspense>
          </div>
        )}
      </CSSTransition>
    </SwitchTransition>
  );
}

function App() {
  return (
    
      <div className="App">
        <BrowserRouter>
          <AppNavbar />
          <Routes>
            <Route path="/" element={<AnimatedRoutes />}>
              {routes.map((route) => (
                <Route
                  key={route.path}
                  index={route.path === '/'}
                  path={route.path === '/' ? undefined : route.path}
                  element={<route.Component />}
                />
              ))}
            </Route>
          </Routes>
        </BrowserRouter>
        <FooterComponent />
      </div>

  );
}
export default App;
